import { environment } from "src/environments/environment.development";
import { iApprovalsList } from "./Interfaces/approvals-list";

export const ApprovalsList: iApprovalsList[] = [
    {
        key: 'leave',
        title: 'Leaves',
        icon: 'assets/images/icons/home/leave-approval.svg',
        route: '/hr360/leave-management/approval',
        right: 'F1047',
        isExternal: false,
        count: 0
    },
    {
        key: 'appraisal',
        title: 'Appraisals',
        icon: 'assets/images/icons/home/appraisals-approval.svg',
        route: `${environment.appraisals_url}/app/form-approvals`,
        right: 'F1181',
        isExternal: true,
        count: 0
    },
    {
        key: 'easyForm',
        title: 'Easy Forms',
        icon: 'assets/images/icons/home/form-approvals.svg',
        route: `${environment.easy_form_url}/app/form-approvals`,
        right: 'E1000',
        isExternal: true,
        count: 0
    },
    {
        key: 'jobRequest',
        title: 'Job Requests',
        icon: 'assets/images/icons/home/recruitment-approvals.svg',
        route: '/hr360/recruitment/approvals',
        right: 'F1112',
        isExternal: false,
        count: 0
    },
    {
        key: 'jobRequisition',
        title: 'Job Requisitions',
        icon: 'assets/images/icons/home/recruitment-approvals.svg',
        route: '/hr360/recruitment/job-requisition/approvals',
        right: 'F2284',
        isExternal: false,
        count: 0
    },
    {
        key: 'purchaseRequisition',
        title: 'Purchase Requisition',
        icon: 'assets/images/icons/home/pr.svg',
        route: `${environment.inventory_url}/pr`,
        right: 'A1012',
        isExternal: true,
        count: 0
    },
    {
        key: 'procurement',
        title: 'Procurement',
        icon: 'assets/images/icons/home/procurement.svg',
        route: `${environment.inventory_url}/procurement`,
        right: 'A1012',
        isExternal: true,
        count: 0
    },
    {
        key: 'purchaseOrder',
        title: 'Purchase Order',
        icon: 'assets/images/icons/home/purchase-order.svg',
        route: `${environment.inventory_url}/allpo`,
        right: 'A1067',
        isExternal: true,
        count: 0
    },
    {
        key: 'backupRequests',
        title: 'Backup Requests',
        icon: 'assets/images/icons/home/ef_backup_request.svg',
        route: `${environment.easy_fee_base_url}/backupRequests`,
        right: 'D1448',
        isExternal: true,
        count: 0,
    },
    {
        key: 'transferRequests',
        title: 'Transfer Requests',
        icon: 'assets/images/icons/home/ef_transfer_request.svg',
        route: `${environment.easy_fee_base_url}/transfer-requests`,
        right: 'D1452',
        isExternal: true,
        count: 0,
    },
    {
        key: 'leaveRequests',
        title: 'Leave Requests',
        icon: 'assets/images/icons/home/ef_leave_request.svg',
        route: `${environment.easy_fee_base_url}/leave-requests`,
        right: 'D1968',
        isExternal: true,
        count: 0,
    },
];